import { ShieldCheck, Clock, Award } from "lucide-react";

export function TrustBar() {
  const items = [
    { icon: ShieldCheck, label: "Durable, long-lasting floors", desc: "Made to withstand daily wear and tear." },
    { icon: Clock, label: "Expert installation", desc: "Precise, clean, and on time — every time." },
    { icon: Award, label: "Trusted by homeowners", desc: "Proven quality and customer satisfaction." },
  ];
  return (
    <div className="border-y border-border bg-secondary/40">
      <div className="container-page py-8 grid grid-cols-1 md:grid-cols-3 gap-6">
        {items.map((it) => (
          <div key={it.label} className="flex items-start gap-3">
            <div className="flex-shrink-0 rounded-full bg-accent/10 p-2.5">
              <it.icon className="h-5 w-5 text-accent" />
            </div>
            <div>
              <div className="text-sm font-semibold text-foreground">{it.label}</div>
              <div className="text-sm text-muted-foreground">{it.desc}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

